import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { setMobileMapViewInteractionTrigger } from 'store/spots/spots-actions';
export const useHandleOnPan = ({ onPanProp, }) => {
    const dispatch = useDispatch();
    return useCallback((options) => {
        dispatch(setMobileMapViewInteractionTrigger({ trigger: 'pan' }));
        if (onPanProp) {
            onPanProp(options);
        }
    }, [dispatch, onPanProp]);
};
